import { memo } from 'react';

import { SvgIcon } from '@material-ui/core';

import { SvgIconProps } from './SvgIcon.types';

export const DollarCircleIcon = memo(({ className }: SvgIconProps) => (
  <SvgIcon
    className={className}
    width="33"
    height="33"
    viewBox="0 0 33 33"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={{ fill: 'none' }}
  >
    <path
      d="M17.4514 32.0779C25.7852 32.0779 32.5416 25.3215 32.5416 16.9877C32.5416 8.65395 25.7852 1.89752 17.4514 1.89752C9.11764 1.89752 2.36121 8.65395 2.36121 16.9877C2.36121 25.3215 9.11764 32.0779 17.4514 32.0779Z"
      fill="#F0CBA7"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0.458374 15.9462C0.458374 7.34794 7.42924 0.377075 16.0275 0.377075C24.6258 0.377075 31.5967 7.34794 31.5967 15.9462C31.5967 24.5445 24.6258 31.5154 16.0275 31.5154C7.42924 31.5154 0.458374 24.5445 0.458374 15.9462ZM16.0275 1.33498C7.95828 1.33498 1.41628 7.87698 1.41628 15.9462C1.41628 24.0155 7.95828 30.5575 16.0275 30.5575C24.0968 30.5575 30.6388 24.0155 30.6388 15.9462C30.6388 7.87698 24.0968 1.33498 16.0275 1.33498Z"
      fill="#EA7200"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.0276 9.6167C14.6077 9.6167 13.454 10.7704 13.454 12.1903C13.454 13.6101 14.6077 14.7638 16.0276 14.7638C17.9412 14.7638 19.4952 16.3178 19.4952 18.2315C19.4952 20.1451 17.9412 21.6991 16.0276 21.6991C14.1139 21.6991 12.5599 20.1451 12.5599 18.2315C12.5599 17.9846 12.7601 17.7844 13.007 17.7844C13.2538 17.7844 13.454 17.9846 13.454 18.2315C13.454 19.6513 14.6077 20.805 16.0276 20.805C17.4474 20.805 18.6011 19.6513 18.6011 18.2315C18.6011 16.8116 17.4474 15.6579 16.0276 15.6579C14.1139 15.6579 12.5599 14.1039 12.5599 12.1903C12.5599 10.2766 14.1139 8.72266 16.0276 8.72266C17.9412 8.72266 19.4952 10.2766 19.4952 12.1903C19.4952 12.4372 19.295 12.6373 19.0482 12.6373C18.8013 12.6373 18.6011 12.4372 18.6011 12.1903C18.6011 10.7704 17.4474 9.6167 16.0276 9.6167Z"
      fill="#226937"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.0273 6.72382C16.2742 6.72382 16.4744 6.92395 16.4744 7.17084V9.18244C16.4744 9.42933 16.2742 9.62946 16.0273 9.62946C15.7805 9.62946 15.5803 9.42933 15.5803 9.18244V7.17084C15.5803 6.92395 15.7805 6.72382 16.0273 6.72382Z"
      fill="#226937"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.0273 20.8045C16.2742 20.8045 16.4744 21.0046 16.4744 21.2515V23.2631C16.4744 23.51 16.2742 23.7102 16.0273 23.7102C15.7805 23.7102 15.5803 23.51 15.5803 23.2631V21.2515C15.5803 21.0046 15.7805 20.8045 16.0273 20.8045Z"
      fill="#226937"
    />
  </SvgIcon>
));
